import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteResultComponent } from "app_locobook/pages/quote-page/components/quote-result/quote-result.component";
import { BookingModule } from "app_locobook/shared/booking/booking.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PropalModule } from 'app_locobook/service/propal/propal.module';
import { LowCostCompanyModule } from 'app_locobook/service/low-cost-company.module';
import { FareFamilyBenchmarkModule } from "../fare-family-benchmark/fare-family-benchmark.module";
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { ClickStopModule } from "libraries/directive/clickstop/click-stop.module";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
  declarations: [
    QuoteResultComponent
  ],
    imports: [
        CommonModule,
        BookingModule,
        BtnModule,
        FontAwesomeModule,
        PropalModule,
        LowCostCompanyModule,
        FareFamilyBenchmarkModule,
        LoaderModule,
        NotificationModule,
        ClickStopModule,
        PermissionModule,
    ],
  exports: [
    QuoteResultComponent
  ],
})
export class QuoteResultModule { }
